import { Typography } from 'antd';

import type { RecentKeyword } from '@/shared/lib/storage';
import { Chip } from '@/shared/ui/Chip';

import styles from './SearchResultKeyword.module.css';

const { Text } = Typography;

type SearchResultKeywordProps = {
  recentKeywords: RecentKeyword[];
  onClickKeyword: (keyword: string) => void;
  onClickRemoveKeyword: (keyword: string) => void;
};

export const SearchResultKeyword = ({
  recentKeywords,
  onClickKeyword,
  onClickRemoveKeyword,
}: SearchResultKeywordProps) => {
  return (
    <div className={styles.section}>
      <Text className={styles.sectionTitle}>최근 검색</Text>
      <div className={styles.keywordTags}>
        {recentKeywords.map((item) => (
          <Chip
            key={item.keyword}
            label={item.keyword}
            onClick={() => onClickKeyword(item.keyword)}
            onClose={() => onClickRemoveKeyword(item.keyword)}
          />
        ))}
      </div>
    </div>
  );
};
